import selectNewConversationUponRowRemoval from './selectNewConversationUponRowRemoval';
import TableOperations from 'mini-mail-list-table-operations';
import type TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import tryLoadMoreUponRowRemove from '../tables/tryLoadMoreUponRowRemove';

/**
 * Removes the given row from the list view store and selects the next item.
 * @param rowIds - the rowIds to remove
 * @param tableView - the table to remove them from
 */
export default function removeRowsFromListViewStoreInternal(
    rowIds: string[],
    tableView: TableView
) {
    let rowIndex = -1;
    const collectionLength = rowIds.length;

    for (let i = 0; i < collectionLength; i++) {
        const rowId = rowIds[i];

        if (tableView.focusInfo.focusedRowId === rowId) {
            // Store the index of the current focused row
            rowIndex = tableView.itemIds.indexOf(rowId);
        }

        // Remove the row from the list view store
        TableOperations.removeRow(rowId, tableView);
    }

    // Load more as needed since we removed some items from view
    tryLoadMoreUponRowRemove(tableView);

    // Follow through with selecting the next row if there is next row present
    rowIndex > -1 && selectNewConversationUponRowRemoval(tableView, rowIndex);
}
